import React from "react";
import { Grid, useTheme } from "@mui/system";
import CustomInput from "../../components/inputs/CustomInput";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { calculateAge } from "../../utils/helper";
import moment from "moment";
import { FormLabel, RadioGroup, FormControlLabel, Radio, useMediaQuery, Box, Paper, Typography } from "@mui/material";
import { GENDER } from "../../utils/constants";
import SubmitButton from "../../components/button/SubmitButton";

const HearNUFormCreateUI = ({
  loading,
  setLoading,
  fields,
  setFields,
  onSubmit,
  handleCaptureMeasurement,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // console.log("fields", fields?.age);
  return (
 
       
       <Box pl={3} pr={3} pb={2} pt={2} sx={{overflow:"hidden"}} component="form" onSubmit={onSubmit}>
        <Paper sx={{overflow:"scroll",scrollbarWidth:"thin"}} elevation={2} >
          <Typography variant="h3" sx={{ mb: 5, mt: 3, textAlign: "center" }}>
            Custom HearNU Form
          </Typography>

          {/* Error Message */}
          {fields?.err && (
            <Box sx={{ ml: 9, mb: 2 }}>
              <Typography color="error">{fields?.err}</Typography>
            </Box>
          )}
          <Typography
            variant="body2"
            sx={{
              textAlign: "Left",
              color: "#555",
              mt: 1,
              // mb: 2,
              ml: 7,
              fontStyle: "italic",
            }}
          >
            * Note: Your data is private and secure. We do not store any camera
            footage, and your measurements are used solely for research purpose.
          </Typography>

          {/* Form Container */}
          <Box
            sx={{
              border: "2px solid #A91674",
              borderRadius: "8px",
              p: 3,
              mt: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: isMobile ? "100%" : "93%",
              margin: "auto",
              scrollbarWidth: "inherit",
              overflowY: "scroll",
              height:"80vh",
            }}
          >
            <Grid
              container
              sx={{ display: "flex", flexDirection: "row" }}
              spacing={isMobile ? 2 : 7}
            >
              {/* Left Section */}
              <Grid width={isMobile ? "100%" : "48%"}>
                <Grid item xs={12} md={6}>
                  {/* Name */}
                  <CustomInput
                    disabled={loading}
                    value={fields.name}
                    onChange={(e) =>
                      setFields({ ...fields, err: "", name: e.target.value })
                    }
                    label="Name*"
                  />

                  {/* DOB & Age Row */}
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid
                      width={isMobile ? "100%" : "55%"}
                      item
                      xs={6}
                      sx={{ mt: 1 }}
                    >
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DesktopDatePicker
                          sx={{ width: "100%" }}
                          format="DD/MM/YYYY"
                          value={fields?.dob ? moment(fields?.dob) : null}
                          onChange={(val) => {
                            if (val && val.isValid()) {
                              const isoString = val.toISOString();
                              setFields({
                                ...fields,
                                err: "",
                                dob: isoString,
                                age: calculateAge(isoString),
                              });
                            } else {
                              setFields({
                                ...fields,
                                err: "",
                                dob: "",
                                age: 0,
                              });
                            }
                          }}
                          label="DOB*"
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={6} width={isMobile ? "100%" : "42%"}>
                      <CustomInput
                        sx={{ width: "100%" }}
                        disabled
                        value={calculateAge(fields?.dob) || fields?.age}
                        label="Age*"
                      />
                    </Grid>
                  </Grid>
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "Left",
                      color: "#555",
                      mt: 2,

                      fontStyle: "italic",
                    }}
                  >
                    *Used for analyzing head size trends across ethnicities.
                  </Typography>
                  {/* Ethnicity */}
                  <CustomInput
                    sx={{ mt: 1 }}
                    disabled={loading}
                    value={fields?.ethnicity}
                    onChange={(e) =>
                      setFields({
                        ...fields,
                        err: "",
                        ethnicity: e.target.value,
                      })
                    }
                    label="Ethnicity*"
                  />

                  {/* Gender Selection */}
                  <Grid
                    container
                    alignItems="center"
                    spacing={2}
                    sx={{
                      height: "AUTO",
                      border: "1px solid #101536",
                      borderRadius: "5px",
                      mt: 3,
                      p: 1,
                    }}
                  >
                    <FormLabel sx={{ fontSize: "16px", mr: 2 }}>
                      Gender*
                    </FormLabel>
                    <RadioGroup
                      value={fields?.gender}
                      onChange={(e) =>
                        setFields({
                          ...fields,
                          err: "",
                          gender: Number(e.target.value),
                        })
                      }
                      row
                      name="row-radio-buttons-group"
                    >
                      {Object.keys(GENDER).map((item) => (
                        <FormControlLabel
                          disabled={loading}
                          key={item}
                          value={GENDER[item]}
                          control={<Radio sx={{ color: "#A91674" }} />}
                          label={
                            item.charAt(0).toUpperCase() +
                            item.slice(1).toLowerCase()
                          }
                        />
                      ))}
                    </RadioGroup>
                  </Grid>

                  {/* Country */}
                  <CustomInput
                    sx={{ mt: 3 }}
                    disabled={loading}
                    value={fields?.country}
                    onChange={(e) =>
                      setFields({ ...fields, err: "", country: e.target.value })
                    }
                    label="Country*"
                  />
                </Grid>
              </Grid>

              {/* Right Section */}
              <Grid width={isMobile ? "100%" : "45%"}>
                <Grid item xs={12} md={6}>
                  <SubmitButton
                    disabled={
                      !fields?.name ||
                      !fields?.age ||
                      !fields?.ethnicity ||
                      !fields?.gender ||
                      !fields?.country
                    }
                    sx={{ mt: 1, height: "8vh" }}
                    onClick={handleCaptureMeasurement}
                    title={"take Head Measurement"}
                  />

                  {/* Upper Head Circumference */}
                  <CustomInput
                    sx={{ mt: 3.5 }}
                    disabled={loading}
                    value={fields?.upperHeadCircumference}
                    onChange={(e) => {
                      setFields({
                        ...fields,
                        err: "",
                        upperHeadCircumference: e.target.value,
                      });
                    }}
                    label="Temporal Arc (cm)*"
                    InputLabelProps={{ shrink: true }}
                  />

                  {/* Temporal Bone Width */}
                  <CustomInput
                    sx={{ mt: 3 }}
                    disabled={loading}
                    value={fields?.temporalBoneWidth}
                    onChange={(e) =>
                      setFields({
                        ...fields,
                        err: "",
                        temporalBoneWidth: e.target.value,
                      })
                    }
                    label="Temporal Width (cm)*"
                    InputLabelProps={{ shrink: true }}
                  />

                  {/* Forehead to Backhead Circumference */}
                  <CustomInput
                    sx={{ mt: 3 }}
                    disabled={loading}
                    value={fields?.foreheadToBackheadCircumference}
                    onChange={(e) =>
                      setFields({
                        ...fields,
                        err: "",
                        foreheadToBackheadCircumference: e.target.value,
                      })
                    }
                    label="Head Circumference (cm)*"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Submit Button */}
            <Box sx={{ mt: { xs: 2, sm: 3 }, textAlign: "center" }}>
              <SubmitButton onClick={onSubmit} title="Submit" type="submit" />
            </Box>
          </Box>
        </Paper>
      </Box>
   
  );
};

export default HearNUFormCreateUI;
